import {atom} from "recoil";

const showResetAtom = atom({
    key: 'showReset',
    default: false
});

export default showResetAtom;